// MilestoneRecorder - 3D の画面を作り直してから撮る区切り（開いた・AIでつくった・もどした）を、
// 作り終えた画面を撮って記録に残す。開いたままのときは 10 分ごとに、前の区切りから中身が変わっていれば
// 「とちゅうの きろく」を残す（じゆうにつくると同じ。docs/edit-history-undo.md）
import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "app/store";
import { actions } from "features/builder/slice";
import { PieceMilestone } from "features/builder/types";
import { useBuilderScene } from "features/builder/context";
import { recordMilestoneWithCapture } from "features/builder/hook";

const AUTO_MILESTONE_INTERVAL_MS = 10 * 60 * 1000;

export const MilestoneRecorder = () => {
  const dispatch = useDispatch<AppDispatch>();
  const scene = useBuilderScene();
  const pending = useSelector((state: RootState) => state.builder.pendingMilestones[0]);
  const sceneLoadSeq = useSelector((state: RootState) => state.builder.sceneLoadSeq);
  const recording = useRef(false);
  // 撮り終えたら、次の区切りを見に行く
  const [recorded, setRecorded] = useState(0);
  const sceneRef = useRef(scene);

  useEffect(() => {
    sceneRef.current = scene;
  }, [scene]);

  // 頼まれたあとに画面を作り終えたら撮る（作り終える前に撮ると、前のマップが写る）。
  // 作り終えた回数（redux）はすぐ描き直されるが、context の scene は 1 回遅れて新しくなる。
  // 破棄した前の scene のあいだは待つ。
  // 先に列から外す（撮っているあいだに画面を離れて残りを flushPendingMilestones しても、2 回残さない）
  useEffect(() => {
    if (!pending || recording.current || sceneLoadSeq <= pending.afterSeq) return;
    if (!scene || scene.isDisposed) return;
    recording.current = true;
    dispatch(actions.shiftMilestone());
    dispatch(recordMilestoneWithCapture(scene, pending.action_type, pending.payload)).finally(
      () => {
        recording.current = false;
        setRecorded((n) => n + 1);
      },
    );
  }, [pending, sceneLoadSeq, scene, recorded, dispatch]);

  useEffect(() => {
    const timer = window.setInterval(() => {
      dispatch(recordMilestoneWithCapture(sceneRef.current, PieceMilestone.AUTO));
    }, AUTO_MILESTONE_INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, [dispatch]);

  return null;
};
